const module = { name: 'mobile/searchAutocomplete/form/events', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { fd_location as fd_location_locationFormEvents_getLocation } from 'require-global';

const { locationFormEvents, getLocation } = fd_location_locationFormEvents_getLocation;


import { fd_url_manager as links } from 'require-core';



import { Fandango as Fandango } from 'require-core';



const { context: { featureFlags: { searchLocation } } } = Fandango


let { deferredAnalyticsData } = Fandango


import { Fandango_adobeLaunch as adobeLaunch } from 'require-global';



import { Fandango_geolocator as geolocator } from 'require-global';



import { Fandango_util as util } from 'require-global';



import { Fandango_xhr as xhr } from 'require-core';



const KeyCodes = {
    ENTER: 13
}


const MINIMUM_CHAR_COUNT = 1


const REQ_TIMEOUT = 11 * 1000


const TYPING_DEBOUNCE_INTERVAL = 700


const MAX_RESULTS = 4


const Msgs = {
    NO_RESULTS: '<p>No matches found</p>',
    ERROR: '<p>We\'ve had a problem finding matches.</p>',
    SLOW: '<p>Search is taking too long to respond.</p>'
}


const RegExes = {
    MULTIPLE_SPACES: /\s+/g,
    THEATER_LINK: /\/theater-page\b/,
    THEATER_SPLASH_LINK: /\/theaters/,
    ZIP5: /^[0-9]{5}$/
}


let input


let output


let statusElement


let lastSearch = -1


const history = {}


let reqCount = 0


const options = {
    maxResults: MAX_RESULTS,
    keyword: ''
}
function historyAdd(key, value) {
    history[key] = value;
}
function historyFind(key) {
    return history[key] || false;
}
function clearResults() {
    output.innerHTML = '';
    if (statusElement) {
        statusElement.textContent = '';
    }
}
function cleanInput(keyword) {
    if (!keyword) {
        return '';
    }
    return keyword
        .replace(RegExes.MULTIPLE_SPACES, ' ')
        .trim();
}
function isZipCode(keyword) {
    return RegExes.ZIP5.test(keyword);
}
function setResults(markup) {
    output.innerHTML = markup || Msgs.NO_RESULTS;
}
function showBusy() {
    output.innerHTML = '<span class="fd-loading fd-loading--block"></span>';
}
function onSearchDone(data, isManualSearch) {
    reqCount--;
    const results = data && data.data;
    let dataEvent = {};
    if (deferredAnalyticsData) {
        dataEvent = deferredAnalyticsData;
        deferredAnalyticsData = null;
    }
    if (!results || data.error) {
        if (reqCount === 0) {
            setResults(data && data.error ? Msgs.ERROR : Msgs.NO_RESULTS);
            if (statusElement) {
                statusElement.textContent = 'No suggestions found';
            }
        }
        adobeLaunch.track(Object.assign(dataEvent, {
            event: adobeLaunch.EventTypes.SEARCH_RESULTS,
            pageType: 'search results',
            pageName: 'search results',
            internalSearchTerm: data && data.search || lastSearch,
            internalSearchType: isManualSearch ? 'manual' : 'automatic',
            internalSearchMoviesResults: '0',
            internalSearchTheatersResults: '0'
        }));
        return;
    }
    const viewModel = {
        theaters: Array.isArray(results.theaters) ? results.theaters.slice(0, options.maxResults) : [],
        movies: Array.isArray(results.movies) ? results.movies.slice(0, options.maxResults) : [],
        zipcodeSearch: isZipCode(data.search) ? data.search : null
    };
    const markup = (viewModel.theaters.length || viewModel.movies.length)
        ? swig.render('_autocompleteResults', viewModel)
        : null;
    historyAdd(data.search, markup);
    if (data.search !== lastSearch) {
        return;
    }
    setResults(markup);
    if (statusElement) {
        const total = viewModel.movies.length + viewModel.theaters.length;
        statusElement.textContent = total ? `${total} suggestion${total !== 1 ? 's' : ''} found` : 'No suggestions found';
    }
    adobeLaunch.track(Object.assign(dataEvent, {
        event: adobeLaunch.EventTypes.SEARCH_RESULTS,
        pageType: 'search results',
        pageName: 'search results',
        internalSearchTerm: data.search,
        internalSearchType: isManualSearch ? 'manual' : 'automatic',
        internalSearchMoviesResults: '' + viewModel.movies.length,
        internalSearchTheatersResults: '' + viewModel.theaters.length
    }));
}
function onSearchFail() {
    reqCount--;
    if (reqCount === 0) {
        setResults(Msgs.SLOW);
    }
}
function doSearch(keyword, isManualSearch) {
    showBusy();
    reqCount++;
    const url = links.napiAutocompleteSearch();
    const geoLocation = getLocation().params;
    const data = Object.assign({}, geoLocation, {
        search: keyword
    });
    xhr.ajax({
        url,
        method: 'GET',
        data,
        timeout: REQ_TIMEOUT,
        success(data) {
            onSearchDone(data, isManualSearch);
        },
        error: onSearchFail
    });
}
function onChange() {
    const value = cleanInput(input.value);
    const results = historyFind(value);
    if (value === lastSearch && !results) {
        return;
    }
    lastSearch = value;
    if (value.length < MINIMUM_CHAR_COUNT) {
        return clearResults();
    }
    if (results) {
        return setResults(results);
    }
    doSearch(value);
}
function onKeyDown(e) {
    if (e.keyCode === KeyCodes.ENTER) {
        e.preventDefault();
        const keyword = cleanInput(e.target.value);
        if (!keyword) {
            return;
        }
        const redirect = links.mwebSearch({}, {
            q: keyword
        });
        util.navigate(redirect);
    }
}
function onResultsClick(e) {
    const button = e.target.type === 'button' ? e.target : $(e.target).closest('button').get(0);
    if (button && searchLocation && button.dataset.location) {
        showBusy();
        geolocator.setUserLocationCookie(input.value, (err, results) => {
            if (err) {
                alert('Sorry, we couldn\'t find the location you entered. Please try a different location.');
                return;
            }
            if (results && results.mismatch) {
                setResults(historyFind(lastSearch));
                return;
            }
            const location = geolocator.getUserLocation();
            adobeLaunch.track({
                event: adobeLaunch.EventTypes.SEARCH_ZIP_CODE_CLICKED,
                zipCode: location.postal,
                cityState: (location.city || '') + (location.city && location.region ? ', ' : '') + (location.region || '')
            });
            locationFormEvents.updateLocationHistory(results);
            util.navigate(links.tspMovieTimes());
        }, { supportedCountries: ['GB', 'IE', 'US'] });
        return;
    }
    const anchor = e.target.href ? e.target : $(e.target).closest('a').get(0);
    if (!anchor) {
        return;
    }
    const clickType = RegExes.THEATER_LINK.test(anchor.href) ? 'theaters' : 'movies';
    adobeLaunch.track({
        event: adobeLaunch.EventTypes.INTERNAL_SEARCH_RESULT_CLICK,
        internalSearchResultsClickType: clickType,
        internalSearchResultsClickText: anchor.innerText,
        internalSearchTerm: lastSearch
    });
}
function init(inputElement, outputElement, opts) {
    Object.assign(options, opts || {});
    input = inputElement;
    output = outputElement;
    statusElement = opts && opts.statusElement;
    input.addEventListener('input', util.debounce(TYPING_DEBOUNCE_INTERVAL, input, {}, onChange));
    input.addEventListener('fd.clearable.clear', onChange);
    input.addEventListener('keydown', onKeyDown);
    output.addEventListener('click', onResultsClick);
    if (options.keyword) {
        lastSearch = options.keyword;
        doSearch(options.keyword, options.isManualSearch);
    }
}
module.exports = {
    init,
    cleanInput
};
export default module.exports;